/** @format */

import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

export default function useInfiniteScrollSearch<DataType extends { id: string | number; categoryId?: number }>(options: {
  size: number;
  queryKey: string;
  getSearchAfter?: (item: DataType) => unknown;
}) {
  const [items, setItems] = useState<DataType[]>([]);
  const [search, _setSearch] = useState('');
  const [searchAfter, setSearchAfter] = useState<any>(null);
  const [hasMore, setHasMore] = useState(true);

  const queryClient = useQueryClient();

  const setSearch = (v) => {
    _setSearch(v);
    setSearchAfter(null);
  };

  const fetchNext = useCallback(() => {
    if (items && !!items.length) {
      const last = items[items.length - 1];
      if (options.getSearchAfter) {
        return setSearchAfter(options.getSearchAfter(last));
      }
      const lastId = last.id;
      const lastCategory = last.categoryId;
      if (lastCategory) {
        return setSearchAfter([lastCategory, lastId]);
      }
      setSearchAfter(lastId);
    }
  }, [items, options.getSearchAfter]);

  const refetch = () => {
    setSearch('');
    queryClient.invalidateQueries({ predicate: (query) => query.queryKey.includes(options.queryKey) });
  };

  const updateResults = (data: Array<DataType>) => {
    setItems((items) => (!searchAfter ? data : [...items.filter((result) => !data.map((d) => d.id).includes(result.id)), ...data]));
    if (data.length < options.size) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  };

  return { items, setItems, search, setSearch, fetchNext, updateResults, hasMore, searchAfter, refetch };
}
